import { render, staticRenderFns } from "./Ventap.vue?vue&type=template&id=0c5be620&"
import script from "./Ventap.vue?vue&type=script&lang=js&"
export * from "./Ventap.vue?vue&type=script&lang=js&"
import style0 from "./Ventap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports